import * as React from "react";

// style, design
import BaseTable from "src/components/Lists/Base/FinalTable/BaseTable";
import columnDefs from "./listDefs";

// store, state
import { constants, detailUrl } from "../../../store/pipes";
import { useFilteredRealEstates } from "../../../store/realEstates";

export default function PipesTable({
  persistantQuery,
  isBare,
  ignoreLocalStorage,
  tableId,
  onRowClicked,
  checkRowHighlighted,
  onRowSelected,
}) {
  const [realEstates] = useFilteredRealEstates("");

  const columns = React.useMemo(() => {
    const data = columnDefs(realEstates);
    return data;
  }, [persistantQuery, realEstates]);

  const badges = {};
  const filters = {};

  return (
    <BaseTable
      tableId={tableId || "pipes_full_table"}
      title={"Annonsprojekt"}
      onRowClickedWithDetail={(obj) =>
        detailUrl({
          id: obj.id,
        })
      }
      {...{
        isBare,
        ignoreLocalStorage,
        onRowClicked,
        columns,
        persistantQuery,
        badges,
        filters,
        constants,
        checkRowHighlighted,
        onRowSelected,
      }}
    />
  );
}
